<template>
  <div v-if="isOpen === true">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="button_close_modal">
            <a @click="closeModal()">X</a>
          </div>
          <div>
            <h2>{{ $t('title_popup') }}</h2>
            <p v-if="link.status == 1">{{ $t('text_popup_in_progress') }}</p>
            <p v-if="link.status == 0">{{ $t('text_popup_create') }}</p>
          </div>
          <div class="button_modal">
            <a :href="link.action" class="btn">{{ $t('_78') }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModalQuestions",

  props: {
    link: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      isOpen: false,
    }
  },

  mounted() {
    if(!window.location.pathname.includes(this.link.action)) {
      this.isOpen = true;
    }

  },

  methods: {
    closeModal: function () {
      this.isOpen = false;
    }
  },
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 40%;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.button_close_modal {
  display: flex;
  justify-content: flex-end;
}

.button_close_modal a {
  text-decoration: none;

}

.button_modal {
  display: flex;
  justify-content: flex-end;
}

</style>
